module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/fUyyEx/images/e9781439636350_cover.jpg?1684305980475",
      "alt": "This image is the cover for the book Point Piedras Blancas, Images of America"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Point Piedras Blancas, Images of America\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("For thousands of years, Point Piedras Blancas, located along the central coast of California, has attracted people to its rocky, windswept shores. In ancient times, it was used by Native American cultures. Since 1875, it has been the site of a First Order Lighthouse, warning ships to steer clear of its rocky shoals, a duty it continues to fulfill. Although the years have not been kind to this stunning area nor to the lighthouse, new life is being breathed into it by a partnership of enthusiastic community volunteers and government agencies. Their common goal is to restore this magnificent site to its original state while reintroducing the natural environment that was almost obliterated during the past four decades.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John H. Bogacki, Carole Adams\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Authors Carole Adams and John Bogacki are both deeply involved with the efforts to restore Point Piedras Blancas. Adams is a volunteer at the Piedras Blancas Light Station, and Bogacki is a former site manager. They have created a visual representation of the story of Point Piedras Blancas using photographs, illustrations, and architectural drawings that are part of the Bureau of Land Management Piedras Blancas Light Station Collection. The authors� proceeds go to the Piedras Blancas Light Station Association for restoration and education.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0